'use client';

import React__default from 'react';

var LinkedInIcon = function () {
    return (React__default.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("path", { d: 'M7.1157 21.1091H3V8.76198H7.1157V21.1091ZM5.05867 7.1157C3.92027 7.1157 3 6.19296 3 5.05703C3 3.92109 3.92192 3 5.05867 3C6.19296 3 7.1157 3.92274 7.1157 5.05703C7.1157 6.19296 6.19296 7.1157 5.05867 7.1157ZM21.9322 21.1091H17.9754V15.1002C17.9754 13.6671 17.9482 11.8241 15.9184 11.8241C13.858 11.8241 13.5411 13.3847 13.5411 14.9964V21.1091H9.58512V8.75293H13.3831V10.4412H13.4366C13.9651 9.46988 15.2566 8.4459 17.1827 8.4459C21.1914 8.4459 21.9322 11.005 21.9322 14.3322V21.1091Z', fill: '#888' })));
};
var LinkedInIcon$1 = React__default.memo(LinkedInIcon);

export { LinkedInIcon$1 as default };
//# sourceMappingURL=index.js.map
